var symphony = symphony || {};

symphony.commConnSearch = {
    canIntegrateWithCommConn: function () {
        return typeof commConnApiUrl != "undefined" && commConnApiUrl != '' && ((typeof krocCenterId != "undefined" && krocCenterId != '') || (symphony && symphony.siteSettings && symphony.siteSettings.data && symphony.siteSettings.data.krocCenterId && symphony.siteSettings.data.krocCenterId != ''));
    },
    allCommConnSaleItems: [],

    getCommConnSalesItems: function (searchTerm, searchType, callback) {
        searchTerm = searchTerm || "";
        searchType = searchType || 0;
        if (this.canIntegrateWithCommConn()) {
            if (this.allCommConnSaleItems.length == 0 || searchType != 0 || searchTerm != "") {
                $.ajax({
                        type: 'POST',
                        url: commConnApiUrl + '/api/sales-search/search',
                        data: JSON.stringify({
                            "centerId": typeof krocCenterId != "undefined" ? krocCenterId : symphony.siteSettings.data.krocCenterId,
                            "searchType": searchType,
                            "searchTerm": searchTerm
                        }),
                        contentType: 'application/json'
                    })
                    .done(function (resp) {
                        var finalList = [];
                        // only get unique class instances
                        var uniqueClassInstanceIds = [];
                        for (var i = 0; i < resp.data.items.length; i++) {
                            if (resp.data.items[i].resultType == 1 && resp.data.items[i].classInstanceId) {
                                if (uniqueClassInstanceIds.indexOf(resp.data.items[i].classInstanceId) == -1) {
                                    finalList.push(resp.data.items[i]);
                                    uniqueClassInstanceIds.push(resp.data.items[i].classInstanceId);
                                }
                            } else {
                                finalList.push(resp.data.items[i]);
                            }
                        }

                        if (searchType == 0 && searchTerm == "") {
                            this.allCommConnSaleItems = finalList;
                        }
                        if (typeof callback == "function") {
                            callback(finalList);
                        }
                    });
            } else {
                if (typeof callback == "function") {
                    callback(this.allCommConnSaleItems);
                }
            }
        } else {
            if (typeof callback == "function") {
                callback([]);
            }
        }
    }
};
